import React, { ReactNode, useCallback } from 'react'
import { Button } from '../../../../../components/Button/Button'
import { Offcanvas } from 'react-bootstrap'
import { SidebarTitle, SidebarType } from './models'
import './SummarySidebar.scss'
import { useAppDispatch, useAppSelector } from '../../../../../store/hooks'
import { hideSidebar, selectDisplayedSidebar } from '../../../../../store/meetingSummary/display'
import { Comments } from '../Comments/Comments'
import { Notepad } from '../Notepad/Notepad'
import { NotepadFooter } from '../Notepad/NotepadFooter'
import { ResultExplainer } from '../ResultExplainer/ResultExplainer'
import { ExternalUpdates } from '../ExternalUpdates/ExternalUpdates'
import { BusinessEventSidebar } from '../BusinessEvents/BusinessEventSidebar'

export interface MeetingSummarySidebarProps {
  title: SidebarTitle | string
  icon: string
  footer?: ReactNode
}

export const MeetingSummarySidebar: React.FC = () => {
  const dispatch = useAppDispatch()

  const { displayedSidebar, title, icon } = useAppSelector(selectDisplayedSidebar)

  const getSidebarBody = useCallback(() => {
    if (!displayedSidebar) {
      return null
    }

    switch (displayedSidebar) {
      case SidebarType.COMMENTS:
        return (
          <div className='d-flex flex-column flex-grow-1 summary-sidebar-content-container'>
            <Comments />
          </div>
        )
      case SidebarType.NOTEPAD:
        return (
          <>
            <div className='d-flex flex-column flex-grow-1 summary-sidebar-content-container'>
              <Notepad />
            </div>
            <div>
              <NotepadFooter />
            </div>
          </>
        )
      case SidebarType.RESULT_EXPLAINER:
        return (
          <div className='d-flex flex-column flex-grow-1 summary-sidebar-content-container'>
            <ResultExplainer />
          </div>
        )
      case SidebarType.EXTERNAL_UPDATES:
        return (
          <div className='d-flex flex-column flex-grow-1 summary-sidebar-content-container'>
            <ExternalUpdates />
          </div>
        )
      case SidebarType.BUSINESS_EVENTS:
        return (
          <div className='d-flex flex-column flex-grow-1 summary-sidebar-content-container'>
            <BusinessEventSidebar />
          </div>
        )
    }
  }, [displayedSidebar])

  const closeSidebar = () => {
    dispatch(hideSidebar())
  }

  return (
    <Offcanvas show={!!displayedSidebar} placement='end' className='summary-sidebar-container' onHide={closeSidebar} scroll backdrop={false}>
      <div className='h-100 py-3 pe-4 ps-3 d-flex flex-column mb-9'>
        <div className='d-flex p-4 align-items-center justify-content-between summary-sidebar-header'>
          <div className='d-flex align-items-center gap-2'>
            <i className={`bi ${icon} text-white`} />
            <div className='paragraph-large bold text-white'>{title}</div>
          </div>
          <Button variant='link' onClick={closeSidebar}>
            <i className='bi bi-x-lg text-white' />
          </Button>
        </div>
        <div className='d-flex flex-column zocks-gap-2 flex-grow-1 overflow-auto'>{getSidebarBody()}</div>
      </div>
    </Offcanvas>
  )
}
